'use strict';

module.exports = {
    MEDIA_SHUTTLE: 'MEDIA_SHUTTLE',
    PORTAL_LEVEL_SAML: 'PORTAL_LEVEL_SAML',
    ACCOUNT_LEVEL_SAML: 'ACCOUNT_LEVEL_SAML',
    PLATFORM_SAML: 'PLATFORM_SAML'
};